export const QUERY_KEYS = {
  PROCESS_START_SETTINGS: ['processStartSettings'], // GetProcessStartSettings
  STUDY_LINES: ['studyLines'], // GetStudyLines
  ORGANIZATIONS: ['organizations'],
  STUDENT_INTERNSHIP_PROCESSES: ['studentInternshipProcesses'], // GetInternshipApplicationsById, GetInternshipById
  ACTIVE_INTERNSHIP_OFFERS: ['activeInternshipOffers'],
  RESEARCH_AGREEMENTS: ['researchAgreements'],
  TUTORS_OF_ORGANIZATIONS: ['tutorsOfOrganization'], // GetTutorsOfOrganization
  INTERNSHIP_PROCESSES_OF_SUPERVISOR_AXIOS: ['internshipProcesses'], // getInternshipProcessesOfUniversitySupervisor
  APPLICATION_COUNT: ['applicationCount'],
  STUDENT_COUNT: ['studentCount'],
  CONVENTIONS_TO_BE_SIGNED_COUNT: ['conventionsToBeSignedCount'],
  INTERNSHIPS_APPLICATIONS_AND_APPLICANTS_OF_ORGANIZATION: [
    'InternshipsApplicationsAndApplicantsOfOrganization',
  ],
  DEPARTMENTS: ['departments'],
  PROCESSES_BY_UNIVERSITY_DEPARTMENT: ['processesByUniversityDepartment'],
  TEACHING_STAFF_OF_UNIVERSITY_DEPARTMENT: [
    'teachingStaffOfUniversityDepartment',
  ],
  EVALUATED_PROCESSES: ['evaluatedProcesses'],
  STUDENT_DATA: ['studentData'],
  INTERNSHIP: ['internship'],
  USER: ['user'],
  SUPERVISOR_NOT_IN_DEPARTMENT: ['supervisorNotInDepartment'],
  INTERNSHIP_OFFERS_OF_ORGANIZATION: ['internshipOffersOfOrganization'], // GetInternshipOffersOfOrganization
  INTERNSHIP_PROCESSES_BY_USER_ID: ['internshipProcessesByUserId'], // GetInternshipProcessesByUserId
  STUDENTS_APPLIED_TO_INTERNSHIP_OFFER: ['studentsAppliedToInternshipOffer'], // GetInternshipOffersOfOrganization
  INTERNSHIP_PROCESSES_BY_ORGANIZATIONS: ['internshipProcessesByOrganizations'], // GetInternshipProcessesByOrganizations
  INTERNSHIP_PROCESSES_OF_TUTOR: ['internshipProcessesOfTutor'], // GetInternshipProcessesOfTutor
  INTERNSHIP_PROCESSES_OF_SUPERVISOR: ['internshipProcessesOfSupervisor'], // GetInternshipProcessesOfUniversitySupervisor
  INTENRSHIP_PROCESSES_OF_RECTOR: ['internshipProcessesOfRector'], // GetInternshipProcessesForRector
  INTERNSHIP_PROCESSES_BY_ROLE: ['internshipProcessesByRole'], // call get internshipProcesses by role
  CONVENTIONS: ['conventions'], // GetAllRegisteredConventionDocuments
  INTERNSHIP_PROCESSES_READY_TO_SIGN_BY_TUTOR: [
    'internshipProcessesReadyToSignByTutor',
  ],
  WORK_REPORTS_READY_TO_SIGN_BY_TUTOR: ['workReportsReadyToSignByTutor'],
  ONGOING_PROCESSES_OF_TUTOR: ['ongoingProcessesOfTutor'],
  WAITING_FOR_REVIEW_PROCESSES_OF_TUTOR: ['waitingForReviewProcessesOfTutor'],
  ACCEPTED_PROCESSES_OF_TUTOR: ['acceptedProcessesOfTutor'],
  EVALUATED_PROCESSES_OF_TUTOR: ['evaluatedProcessesOfTutor'],
  NUMBER_OF_TASKS_TUTOR: ['numberOfTasksTutor'],
  PENDING_CONVENTIONS: ['pendingConventions'],
  UNREGISTERED_ORGANIZATION_REGISTRATIONS: [
    'unregisteredOrganizationRegistrations',
  ],
  UNSIGNED_ORGANIZATION_REGISTRATIONS: ['unsignedOrganizationRegistrations'],
  SIGNED_ORGANIZATION_REGISTRATIONS: ['signedOrganizationRegistrations'],
  ORGANIZATION_REGISTRATIONS: ['organizationRegistrations'],
  ORGANIZATIONS_TUTORS: ['organizations-tutors'],
  DETAILED_ORGANIZATION_REGISTRATIONS: ['detailedOrganizationRegistrations'],
  DEPARTMENTS_WITH_SUPERVISORS: ['departmentsWithSupervisors'],
};
